import { zodResolver } from "@hookform/resolvers/zod";
import { AlertDialog } from "../../common/AlertDailog";
import DynamicForm from "../../common/DynamicForm";
import { useForm } from "react-hook-form";
import {
  addComponentSchema,
  detailsAddComponentSchema,
} from "./uiConfigSchema";

const AddComponentForm = (props: any) => {
  const {
    addComponentPopup,
    setAddComponentPopup,
    setComponents,
    viewType,
    components,
    entityMetadataList,
    getMetadataFields,
  } = props;

  const fields: any = [
    {
      name: "component_name",
      label: "Component Name",
      size: 6,
      required: true,
    },
    {
      name: "selected_entity",
      label: "Select Entity for Metadata",
      size: 6,
      required: true,
      inputType: "autocomplete",
      options: entityMetadataList,
    },
  ];

  const compType = {
    name: "component_type",
    label: "Select Component Type",
    size: 6,
    inputType: "radio",
    options: ["Card", "Timeline"],
    optionFlex: "row",
  };

  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
  } = useForm({
    resolver: zodResolver(
      viewType == "Details Component"
        ? detailsAddComponentSchema
        : addComponentSchema
    ),
    defaultValues:
      viewType == "Details Component" ? { component_type: "Card" } : {},
  });

  const handleSave = (data: any) => {
    const temp: any = {};
    temp["component_name"] = data.component_name;
    temp["selected_entity"] = data.selected_entity;
    getMetadataFields(temp);
    if (viewType == "List Component") {
      setComponents({
        ...components,
        listComponent: [...components.listComponent, temp],
      });
    } else if (viewType == "Details Component") {
      temp["component_type"] = data.component_type;
      setComponents({
        ...components,
        detailsComponent: [...components.detailsComponent, temp],
      });
    }
    setAddComponentPopup(false);
  };

  const onInvalid = (data: any) => {
    console.debug(data);
  };

  return (
    <AlertDialog
      open={addComponentPopup}
      handleClose={() => setAddComponentPopup(false)}
      handleConfirm={handleSubmit(handleSave, onInvalid)}
      maxWidth="md"
      title="Add Component"
    >
      <DynamicForm
        fieldsJson={
          viewType == "Details Component" ? [...fields, compType] : fields
        }
        register={register}
        control={control}
        errors={errors}
      />
    </AlertDialog>
  );
};

export default AddComponentForm;
